import { createFileRoute, redirect } from "@tanstack/react-router";
import { ConsentPage } from "@/features/connect-ai/consent-page";
import { getAccessToken, refreshSession } from "@/lib/auth-api";
import { rememberPostLoginRedirect } from "@/lib/post-login-redirect";

/**
 * Ekran zgody OAuth „Podłącz AI” — poza layoutem `_auth` (bez menu), na istniejącej
 * sesji. Bez sesji: logowanie i powrót tutaj. Dostęp sprawdza backend (element
 * `page.topbar.connect-ai`), bo prośba przychodzi z zewnętrznej aplikacji AI.
 */
export const Route = createFileRoute("/polacz-ai/zgoda")({
	validateSearch: (search: Record<string, unknown>): { request?: string } => ({
		request:
			typeof search.request === "string" || typeof search.request === "number"
				? String(search.request)
				: undefined,
	}),
	beforeLoad: async ({ location }) => {
		if (getAccessToken()) return;
		if (await refreshSession()) return;
		rememberPostLoginRedirect(location.href);
		throw redirect({ to: "/auth/login" });
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { request } = Route.useSearch();
	return <ConsentPage requestId={request} />;
}
